export const cloneExpenseEntry = "clone-expense-entry";
export const createExpenseEntry = "create-expense-entry";
export const editExpenseEntry = "edit-expense-entry";
